// @flow

import * as React from "react";
import SVG from "react-inlinesvg";

import SuccessIcon from "../../assets/icons/validationSummary/success.svg";
import FailIcon from "../../assets/icons/validationSummary/fail.svg";

import styles from "./ValidationSummary.scss";

type Result = {
  isValid: boolean,
  text: () => React.Node
};

type ValidationSummaryProps = {
  result: Array<Result>
};

const ValidationSummary = ({ result }: ValidationSummaryProps) =>
  result.map<React.Node>(({ isValid, text }, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div className={styles.validationItem} key={index} data-error={!isValid}>
      <div className={styles.iconWrapper}>
        {isValid ? (
          <span data-testid="validIcon">
            <SVG className={styles.icon} src={SuccessIcon} />
          </span>
        ) : (
          <span data-testid="invalidIcon">
            <SVG className={styles.icon} src={FailIcon} data-testid="invalidIcon" />
          </span>
        )}
      </div>
      <span>{text()}</span>
    </div>
  ));

ValidationSummary.defaultProps = {
  result: []
};

export default ValidationSummary;
